import { LogService } from "./log.service";

export abstract class BaseService {
  protected logger: any;

  constructor(
    protected logService: LogService,
    protected serviceName: string,
  ) {
    this.logger = this.logService.registerLogger({
      service: this.serviceName,
    });
  }
}
